import { useEffect } from 'react';
import { useLocation } from '@reach/router';
import { useDispatch, useSelector } from 'react-redux';
import { urlPathChanged, updatePathStack } from '#/shared/slices/history';

function HistoryManager() {
  const { pathStack } = useSelector(s => s.shared.history);
  const dispatch = useDispatch();
  const { back } = useSelector(s => s.shared.history);
  const location = useLocation();

  useEffect(() => {
    if (location.pathname !== pathStack[0]) {
      let nextStack;
      const backObj = {};

      if (back) {
        nextStack = pathStack.slice(1);
        backObj.back = false;
      } else {
        nextStack = [location.pathname, ...pathStack];
      }

      dispatch(updatePathStack(nextStack));
      dispatch(
        urlPathChanged({
          ...backObj,
          currentPathname: nextStack[0],
          previousPathname: nextStack[1] || null,
        })
      );
    }
  }, [back, dispatch, location.pathname, pathStack]);

  return null;
}

export default HistoryManager;
